import { render, staticRenderFns } from "./mg.vue?vue&type=template&id=1e4ede6d&scoped=true"
import script from "./mg.vue?vue&type=script&lang=js"
export * from "./mg.vue?vue&type=script&lang=js"
import style0 from "./mg.vue?vue&type=style&index=0&id=1e4ede6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4ede6d",
  null
  
)

export default component.exports